/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/PolicyHolder/Options/AddRelationship/Content/Details/Title",
  onChange
  
}) {
let titlesTitlesValueData = fromData.useDataValue({ viewPath,
context: 'titles',
path: 'titles',
})
let newRelationPersonTitleValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'person.title',
})
let newRelationPersonTitleChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.title',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 maxWidth={280}
 size="medium"
 data="titles.titles"
 from={titlesTitlesValueData}
 data="new_relation.person.title"
 value={newRelationPersonTitleValueData}
 onChange={newRelationPersonTitleChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Title"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}